export default __webpack_public_path__ + "static/media/rewards.f5314118.webp";